module.exports = __webpack_public_path__ + "img/jovens-talentos-cover.517cae5f.jpg";